import { createSelector } from '@reduxjs/toolkit';
import { createInputBindings } from '@ff-scene-plugins/gift-redux/slices/inputsSlice';
import { createOptionBindings } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { SizeAttributeInput } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeInput';
import { SizeAttributeOptions } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeOptions';

const { createInputSelector, createInputUpdater }
    = createInputBindings<SizeAttributeInput>();

export const selectValueById = createInputSelector(i => i.value);
export const updateValueByIds = createInputUpdater('value');

const { createOptionSelector } = createOptionBindings<SizeAttributeOptions>();

export const selectSizeChoicesById = createOptionSelector(i => i.choices);
export const selectComponentById = createOptionSelector(i => i.component);

export const selectSizeChoiceById = createSelector([
    selectSizeChoicesById,
    selectValueById
], (choices, value) => {
    return choices!.find(c => c.value === value!)!;
});

export const selectHasPreview = createSelector(
    (state: GiftPdpState, variableId: string) => selectSizeChoicesById(state, variableId)!,
    (choices) => choices?.some(c => c.options?.assetUrl));